import React from 'react';
import { motion } from 'framer-motion';
const menuData = [{
  category: 'ראשונות',
  items: [{
    name: 'טרטר בקר',
    description: 'איולי חרדל, צלפים, חלמון כבוש, קרקר מחמצת',
    price: '78'
  }, {
    name: 'סשימי אינטיאס',
    description: "ויניגרט הדרים, שמן צ'ילי, צנונית, כוסברה",
    price: '82'
  }, {
    name: 'כרישה פחמים',
    description: 'קרם פרש, שקדים קלויים, שמן עירית',
    price: '64'
  }, {
    name: 'טורטליני ריקוטה',
    description: "חמאת מרווה, פרמז'ן, פלפל שחור",
    price: '72'
  }]
}, {
  category: 'עיקריות',
  items: [{
    name: 'פילה בקר',
    description: 'פירה תפוחי אדמה, ציר בקר מצומצם, בצלי שאלוט',
    price: '185'
  }, {
    name: 'לברק שלם',
    description: 'צלוי בתנור אבן, ירוקים עונתיים, שמן זית, לימון',
    price: '165'
  }, {
    name: 'ריזוטו פטריות',
    description: "פטריות יער, כמהין, פרמז'ן, חמאה חומה",
    price: '110'
  }, {
    name: 'שקדי עגל',
    description: 'קרם ארטישוק ירושלמי, ציר בקר, ערמונים',
    price: '145'
  }]
}, {
  category: 'קינוחים',
  items: [{
    name: 'נמסיס שוקולד',
    description: 'קרם אנגלז, קראמבל קקאו, גלידת וניל מדגסקר',
    price: '58'
  }, {
    name: 'טארט לימון',
    description: 'מרנג איטלקי חרוך, בצק פריך, קולי פטל',
    price: '54'
  }, {
    name: 'קרם ברולה',
    description: 'וניל, סוכר חום מקורמל, פירות יער',
    price: '52'
  }]
}];
export function Menu() {
  return <section id="menu" className="py-32 bg-dark relative" dir="rtl" data-id="element-73">
      <div className="container mx-auto px-6 md:px-12 max-w-5xl" data-id="element-74">
        <motion.div className="text-center mb-24" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} data-id="element-75">
          <h2 className="font-serif text-5xl md:text-6xl text-cream mb-6" data-id="element-76">
            התפריט
          </h2>
          <div className="w-16 h-[1px] bg-gold mx-auto" data-id="element-77" />
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-24 gap-y-20" data-id="element-78">
          {menuData.map((section, sectionIdx) => <motion.div key={section.category} className={sectionIdx === 2 ? 'lg:col-span-2 lg:w-1/2 lg:mx-auto' : ''} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: sectionIdx * 0.2
        }} data-id="element-79">
              <h3 className="font-serif text-3xl text-gold mb-10 text-center lg:text-right" data-id="element-80">
                {section.category}
              </h3>

              <div className="flex flex-col gap-8" data-id="element-81">
                {section.items.map((item, itemIdx) => <div key={itemIdx} className="group" data-id="element-82">
                    <div className="flex items-baseline mb-2" data-id="element-83">
                      <h4 className="font-serif text-xl text-cream group-hover:text-gold transition-colors" data-id="element-84">
                        {item.name}
                      </h4>
                      <div className="dotted-leader" data-id="element-85" />
                      <span className="font-sans text-lg text-cream" data-id="element-86">
                        {item.price}
                      </span>
                    </div>
                    <p className="font-sans text-sm text-cream/50 pr-2" data-id="element-87">
                      {item.description}
                    </p>
                  </div>)}
              </div>
            </motion.div>)}
        </div>

        <motion.div className="mt-24 text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.5
      }} data-id="element-88">
          <a href="#" className="inline-flex items-center gap-2 text-gold hover:text-cream transition-colors font-sans text-sm uppercase tracking-widest" data-id="element-89">
            <span data-id="element-90">תפריט יין מלא</span>
            <div className="w-8 h-[1px] bg-current" data-id="element-91" />
          </a>
        </motion.div>
      </div>
    </section>;
}